import React, { useState } from "react";
import "./index.scss";
import { NavLink } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import InventoryIcon from "@mui/icons-material/Inventory2";
import GroupIcon from "@mui/icons-material/Group";
import AddIcon from "@mui/icons-material/Add";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { Translate } from "react-auto-translate";

function BottomTabBar({ pathMap = {} }) {
  const [addOpen, setAddOpen] = useState(false);

  const tabs = [
    { path: "/", label: "Dashboard", Icon: DashboardIcon, testId: "bottomtab-dashboard" },
    { path: "/staff", label: "Staff", Icon: GroupIcon, testId: "bottomtab-staff" },
    null, // centre FAB placeholder
    { path: "/clients", label: "Clients", Icon: PeopleAltIcon, testId: "bottomtab-clients" },
    { path: "/inventory", label: "Inventory", Icon: InventoryIcon, testId: "bottomtab-inventory" },
  ];

  return (
    <>
      {/* Add sheet overlay */}
      {addOpen && (
        <div className="btb-add-overlay" onClick={() => setAddOpen(false)}>
          <div className="btb-add-sheet" onClick={(e) => e.stopPropagation()}>
            <NavLink exact to="/" className="btb-add-option" onClick={() => setAddOpen(false)} data-testid="btb-add-appointment">
              <CalendarTodayIcon fontSize="small" />
              <Translate>Add Appointment</Translate>
            </NavLink>
            <NavLink exact to="/clients" className="btb-add-option" onClick={() => setAddOpen(false)} data-testid="btb-add-client">
              <PersonAddIcon fontSize="small" />
              <Translate>Add Customer</Translate>
            </NavLink>
          </div>
        </div>
      )}

      <nav className="bottom-tab-bar" data-testid="bottom-tab-bar">
        {tabs.map((tab, i) => {
          if (tab === null) {
            return (
              <button
                key="fab"
                className="btb-fab"
                onClick={() => setAddOpen((prev) => !prev)}
                data-testid="bottomtab-add"
                aria-label="Add"
              >
                <AddIcon />
              </button>
            );
          }

          const { path, label, Icon, testId } = tab;
          const accessible = path in pathMap;
          if (!accessible) return null;

          return (
            <NavLink
              exact
              key={path}
              to={path}
              className="btb-tab"
              activeClassName="btb-tab--active"
              data-testid={testId}
            >
              <Icon fontSize="small" className="btb-tab-icon" />
              <span className="btb-tab-label">
                <Translate>{label}</Translate>
              </span>
            </NavLink>
          );
        })}
      </nav>
    </>
  );
}

export default BottomTabBar;
